import type { FaireProductEntity } from "../../entity_types/product";

export const p_hgdwhb6qju: FaireProductEntity = {
  token: "p_hgdwhb6qju",
  type: "product",
  name: "NA NARUTO CP Naruto Cap",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl:
    "https://cdn.faire.com/fastly/c729c290129cb0cb3b18eb742d87d55d6717df6dc7e35fd80ec54f1c870de43e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e519dbcf11e2d40160051b4379f1df4a8ee2e371d80e9c4b081d4f5f9e119dd.jpeg",
    "https://cdn.faire.com/fastly/53a9332288b6b18f1785327e54902306658035fff20bb5deb9a77d83bd3e7b8c.jpeg",
    "https://cdn.faire.com/fastly/ad18f64b71604cd5b9574d45a5ba0cb9fdcc1a33b122fedfa3107fc28d010c02.jpeg",
    "https://cdn.faire.com/fastly/4dc5081f211472b2b4d21ac174c988d1bd7928703bfa045f275f09beccac14b7.jpeg",
    "https://cdn.faire.com/fastly/8a1696ca6b8bbfe2566d34d23c4449f9d98a190e985299d7f79c7edc7b1ed95b.jpeg",
    "https://cdn.faire.com/fastly/c1e7730131b2333ebb718533e4b0a3a9ac04ae480f714ebb3b29d9b95c4c3269.jpeg",
    "https://cdn.faire.com/fastly/64cce40b7d36b7e876dbc7a160e36dc0164dfad671ccf72dcc06af9428f7f215.jpeg",
  ],
  priceDollars: 28.58,
  description:
    "Trucker cap with a low cut and curved visor from the Naruto X Hydroponic Official Collaboration featuring the great Naruto in striking pose. Naruto x Hydroponic Official Collaboration/Low cut/Curved visor/Digital printed patch at front",
  tags: [],
  msrpDollars: 62.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:22.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
